import { Injectable } from '@angular/core';
import { AlertFacade, StatusGraphService } from '@core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, debounceTime, map, of, switchMap, tap } from 'rxjs';

import * as actions from './status-graph.actions';

@Injectable()
export class StatusGraphEffects {
  constructor(
    private _actions$: Actions,
    private _service: StatusGraphService,
    private _alertFacade: AlertFacade
  ) {}

  public readonly fetchStatusGraph$ = createEffect(() =>
    this._actions$.pipe(
      ofType(actions.fetchStatusGraph),
      switchMap(() =>
        this._service.fetch().pipe(
          map((statusGraph) =>
            actions.fetchStatusGraphSuccess({ statusGraph })
          ),
          catchError(() => of(actions.fetchStatusGraphFail()))
        )
      )
    )
  );

  public readonly save$ = createEffect(() =>
    this._actions$.pipe(
      ofType(actions.saveStatusGraph),
      debounceTime(500),
      switchMap(({ statusGraph }) =>
        this._service.save(statusGraph).pipe(
          map(() => actions.saveStatusGraphSuccess()),
          tap(() =>
            this._alertFacade.show({
              duration: 5000,
              message: 'Status graph saved',
              type: 'success',
              name: 'test',
              showCloseButton: true,
            })
          ),
          catchError(() => of(actions.saveStatusGraphFail()))
        )
      )
    )
  );
}
